import React, { useState, useEffect } from 'react';

import { Grid, Typography, TextField } from '@mui/material';
import { greyOutEmptyTextField } from '../../Helpers/helpers';

function InstallReportNotes(props) {
  const setNotes = props.setNotes;

  // const [notesData, setNotesData] = useState(null);
  const notesData = props?.notesInfo;

  const handleNotes = (data) => {
    setNotes(data);
  };

  // useEffect(() => {
  //   let data = props.notesInfo;
  //   console.log('INFORMATION ', data.notes);
  //   setNotesData(data.notes);
  // }, [props.notesInfo]);

  return (
    <>
      <Grid item xs={12} md={12} style={{ textAlign: 'left' }}>
        <Typography variant='h6' fontWeight='700' marginTop='10px'>
          Notes
        </Typography>
      </Grid>

      <Grid
        item
        border={'grey solid 1px'}
        xs={12}
        md={12}
        sx={{
          textAlign: 'left',
          borderLeft: 'none',
          background: greyOutEmptyTextField(notesData),
        }}
      >
        <TextField
          size='small'
          fullWidth
          value={notesData}
          onChange={(value) => handleNotes(value.target.value)}
        />
      </Grid>
    </>
  );
}

export default InstallReportNotes;
